import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';
import { BookingAction } from '../../../../../constants';

const TripBookingStatusFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);

  const options = [{
    suggests: [{
      value: BookingAction.BOOK,
      label: 'Booked',
    }, {
      value: BookingAction.HOLD,
      label: 'On hold',
    }, {
      value: BookingAction.SEND_QUOTE,
      label: 'Email Quote Sent',
    }, {
      value: BookingAction.CANCELLED,
      label: 'Canceled',
    }, {
      value: '',
      label: 'Pending',
    }, {
      value: BookingAction.BROCHURE,
      label: 'Brochure',
    }, {
      value: BookingAction.ADVICE,
      label: 'Sent trip for advice',
    },
    {
      value: BookingAction.REQUEST_TO_BOOK,
      label: 'Pending Trip Approval',
    }],
    label: '',
    value: '',
  }];

  const handleChange = useCallback((selectedOptions) => {
    const searchObj = {
      ...tripsSearch.searchObj,
      bookingStatus: selectedOptions,
      page: 1,
    };
    onSearch(searchObj);
  }, [onSearch, tripsSearch.searchObj]);

  return (
    <MultiSelectAutocompleteFilter
      onChange={handleChange}
      options={options}
      values={tripsSearch.searchObj.bookingStatus || []}
      label="Booking status"
      variant="outline"
      filterMaxWidthClass="max-w-full"
    />
  );
};

TripBookingStatusFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
export default memo(TripBookingStatusFilter);
